var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsColorfulLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.156,
    d: "M3 5h4v14H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "colorful-logout-main",
    d: "M6.684 20H4.75C3.232 20 2 18.73 2 17.167V6.833C2 5.27 3.232 4 4.75 4h1.934c.19 0 .336.16.336.354v1.18a.344.344 0 0 1-.336.355H4.75a.93.93 0 0 0-.917.944v10.334c0 .522.41.944.917.944h1.934c.19 0 .344.16.344.354v1.18a.35.35 0 0 1-.344.355zm8.329-12.171 3.157 3.02H9.673a.68.68 0 0 0-.673.69v.92c0 .383.3.69.673.69h8.497l-3.157 3.02a.705.705 0 0 0-.023.999l.615.63c.26.267.687.27.951.003l5.244-5.313a.702.702 0 0 0 0-.98L16.56 6.2a.661.661 0 0 0-.951.003l-.615.63a.701.701 0 0 0 .02.996z",
    fill: "#6173FE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsColorfulLogout);
export default __webpack_public_path__ + "static/media/icons-colorful-logout.27e1e951.svg";
export { ForwardRef as ReactComponent };